import styled from 'styled-components';

export const Content = styled.div`
  float: left;
  width: 100%;
  padding: 20px;

  @media (max-width: 1024px) {
    overflow-x: hidden;
    padding: 0px;
  }
`;

export const LoadArea = styled.div`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Cards = styled.div`
  float: left;
  width: 100%;

  main {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0px;
    float: left;
    width: 100%;
  }

  @media (max-width: 1024px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;

    main {
      width: 100%;
      flex-wrap: nowrap;
      border-collapse: collapse;
      white-space: nowrap;
    }
  }
`;

export const Card = styled.div`
  float: left;
  width: 25%;
  padding: 10px;

  div {
    background: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 8px;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }

  &:nth-child(odd) {
    div {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }
  }

  h1 {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 26px;
  }

  small {
    color: ${({ theme }) => theme.colors.TEXT3};
    font-size: 12px;
    margin: 5px 0 0 0;
  }

  @media (max-width: 1024px) {
    width: 60%;
    padding: 0px;
    margin: 0 10px 0 0;

    &:first-child {
      margin-left: 10px;
    }

    div {
      padding: 15px 20px;
      justify-content: flex-start;
      align-items: flex-start;
    }

    h1 {
      font-size: 16px;
      font-weight: 700;
      text-align: left;
    }

    small {
      font-size: 10px;
      text-align: left;
    }
  }
`;

export const GraphArea = styled.div`
  float: left;
  width: 100%;
  padding: 0px;

  header {
    padding: 1.5rem;
    background: ${({ theme }) => theme.colors.LIGHT1};
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;

    i {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.colors.LIGHT1};
      margin: 0 10px 0 0;
      display: none;
    }

    p {
      display: flex;
      flex-direction: column;
      flex: 1;
      display: none;

      h1 {
        color: ${({ theme }) => theme.colors.TEXT1};
        font-size: 22px;
        text-transform: uppercase;
      }

      h2 {
        color: ${({ theme }) => theme.colors.TEXT4};
        font-size: 14px;
        font-weight: normal;
      }
    }

    div {
      display: flex;
      flex-direction: row;

      button {
        display: flex;
        padding: 8px 15px 8px 15px;
        border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
        border-radius: 8px;
        margin-left: 5px;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        transition: all 0.5s ease;

        &:hover {
          background: #333 !important;
        }

        &.excel {
          background: #179d46;
        }

        &.pdf {
          background: #df4c2a;
        }

        &.sync {
          background: #4080e0ff;
        }

        div {
          display: flex;
          flex-direction: column;
          padding: 0 0 0 5px;

          h3 {
            font-size: 8px;
            text-align: left;
            font-weight: normal;
            color: ${({ theme }) => theme.colors.TEXT2};
            margin: 0px;
          }

          h2 {
            font-size: 12px;
            text-align: left;
            color: ${({ theme }) => theme.colors.TEXT2};
            margin: 0px;
            font-weight: 700;
          }
        }
      }
    }
  }

  main {
    background: ${({ theme }) => theme.colors.LIGHT1};
    float: left;
    width: 100%;
  }

  footer {
    width: 100%;
    float: left;
    border-radius: 0;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.LIGHT1};
  }

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 0px;

    header {
      border-radius: 0px;
      padding: 20px 10px 15px 10px;
      background: ${({ theme }) => theme.colors.LIGHT1};
      flex-direction: column;

      i {
        display: flex;
      }

      p {
        align-items: center;
        display: flex;

        h1 {
          text-align: left;
          font-size: 12px;
        }

        h2 {
          text-align: left;
          font-size: 8px;
        }
      }

      > div {
        margin: 10px 0 0 0;

        button {
          padding: 5px 10px;

          h2 {
            font-size: 10px;
          }

          h3 {
            font-size: 8px;
          }
        }
      }
    }

    > main {
      overflow-y: hidden;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      width: 100%;

      > div {
        width: 200%;
        border-collapse: collapse;
        white-space: nowrap;
      }
    }
  }
`;

export const ToogleInfo = styled.button.attrs({
  type: 'button',
})`
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  padding: 20px;
`;

export const Tags = styled.div`
  float: left;
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 15px;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  > div {
    float: left;
    display: flex;
    width: 100%;
    flex-direction: row;
  }

  button {
    background: ${({ theme }) => theme.colors.LIGHT1};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    cursor: pointer;
    margin: 0 5px 0 0;
    transition: all 0.5s ease;

    &:hover {
      background: ${({ theme }) => theme.colors.LIGHT3};
    }

    &.active {
      background: ${({ theme }) => theme.colors.LIGHT5};
    }

    i {
      margin-right: 10px;
    }

    span {
      color: ${({ theme }) => theme.colors.TEXT1};
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }

  @media (max-width: 1024px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    padding: 10px 0;

    > div {
      width: auto;
      border-collapse: collapse;
      white-space: nowrap;
    }

    button {
      margin: 0px 0px 0px 10px;

      &:last-child {
        margin-right: 10px;
      }

      span {
        font-size: 10px;
      }
    }
  }
`;
